import NavLinks from 'mixins/nav-links.js'
import NavigationLinks from 'components/StaticPage/navigation-links/index.vue'
import Modal from 'components/Modal/Default/Default.vue'
import CallFaq from 'components/StaticPage/FaqBox/FaqBox.vue'
import AppSelect from 'components/Materialize/Select/Default/Default.vue'
import AppSelectCountries from 'components/Materialize/Select/Countries/Countries.vue'
import MyBookingsBox from 'components/StaticPage/MyBookingsBox/MyBookingsBox.vue'
import AppLoadPage from 'components/Loads/LoadPage/LoadPage.vue'
import PageLinks from 'mixins/page-links.js'
import OpeningHours from './opening-hours/index.vue'

export default {
  name: 'view-info-contact',

  mixins: [NavLinks, PageLinks],

  components: {
    Modal,
    CallFaq,
    AppSelect,
    AppSelectCountries,
    MyBookingsBox,
    AppLoadPage,
    NavigationLinks,
    OpeningHours
  },

  fetch({ store }) {
    store.dispatch('header/SET_CONFIG', {
      logo: true,
      menu: true,
      recentSearch: true,
      showFlag: true
    })

    store.dispatch('footer/SET_CONFIG', {
      show: true
    })
  },

  head() {
    return {
      title: this.$t('seo.contact.title'),
      link: this.getPageLinks(),
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: this.$t('seo.contact.title')
        },
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.contact.description')
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.$t('seo.contact.metatitle')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.$t('seo.contact.description')
        }
      ]
    }
  }
}
